import { UseTooltipKeyboardParams } from '../Tooltip.types';

const FOCUSABLE_SELECTOR =
  'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

export const useTooltipKeyboard = ({
  interactive,
  shouldRender,
  tooltipRef,
}: UseTooltipKeyboardParams) => {
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (!interactive || event.key !== 'Tab' || event.shiftKey || !shouldRender) {
      return;
    }

    const firstFocusable = tooltipRef.current?.querySelector<HTMLElement>(FOCUSABLE_SELECTOR);

    if (!firstFocusable) {
      return;
    }

    event.preventDefault();
    firstFocusable.focus();
  };

  return { handleKeyDown };
};
